<template>
  <v-flex class="px-3">
    <div class="data-table-header">
      <span class="data-table-title">
        <slot name="title"></slot>
      </span>
      <div class="d-flex justify-end align-center">
        <slot name="button"></slot>
      </div>
    </div>
    <slot name="table"></slot>
    <slot name="popup"></slot>
  </v-flex>
</template>

<script>

export default {
  name: "TableLayout"
}
</script>